import styles from './UpdateMonthlyToAnnuallySection.module.scss';
import { SubscriptionPlanInfo } from 'src/types';
import { PanelHeader } from './components/PanelHeader';
import { UpdateToAnnuallyButton } from './components/UpdateToAnnuallyButton';
import { UpdateToAnnuallySummarySection } from './components/UpdateToAnnuallySummarySection';

interface UpdateMonthlyToAnnuallySectionProps {
  onClose: () => void;
  selectedPlan?: SubscriptionPlanInfo;
}

/**
 * @deprecated
 */
export const UpdateMonthlyToAnnuallySection = ({
  onClose,
  selectedPlan,
}: UpdateMonthlyToAnnuallySectionProps) => {
  return (
    <div className={styles.root}>
      <PanelHeader onClose={onClose} />

      <div className={styles.mainContainer}>
        <UpdateToAnnuallySummarySection selectedPlan={selectedPlan} />
        <div className={styles.paymentContainer}>
          <UpdateToAnnuallyButton
            selectedPlan={selectedPlan}
            onClosePanel={onClose}
          />
        </div>
      </div>
    </div>
  );
};
